import { DogeWalletAdapter, SignPsbtDogeOptions } from '../types';

declare global {
  interface Window {
    doge: {
      isMyDoge: boolean;
      connect: () => Promise<{
        address: string;
        approved: boolean;
        balance: string;
        publicKey: string;
      }>;
      requestPsbt: (psbt: {
        rawTx: string;
        indexes: Array<number>;
        signOnly: boolean;
      }) => Promise<{ signedRawTx: string }>;
    };
  }
}

export class MyDogeAdapter implements DogeWalletAdapter {
  name = 'MyDoge';
  icon = '/wallets/mydoge.avif';
  link = 'https://mydoge.com/wallet';
  isConnected = false;
  address: string | null = null;
  publicKey: string | null = null;

  openLinkIfNotReady() {
    if (!window.doge || !window.doge.isMyDoge) {
      window.open(this.link, '_blank');
      return;
    }
  }

  async connect() {
    this.openLinkIfNotReady();
    const { address, publicKey } = await window.doge.connect();
    this.isConnected = true;
    this.address = address;
    this.publicKey = publicKey;
  }
  disconnect() {
    this.isConnected = false;
    this.address = null;
  }

  async getPublicKey() {
    this.openLinkIfNotReady();
    if (!this.publicKey) {
      throw new Error('Public key not found');
    }
    return Promise.resolve(this.publicKey);
  }

  async signPsbt(psbt: string, options?: SignPsbtDogeOptions) {
    const requestPsbtData = {
      rawTx: psbt,
      indexes: options?.toSignInputs?.map((input) => input.index) ?? [],
      signOnly: true,
    };
    const signedPsbt = await window.doge.requestPsbt(requestPsbtData);
    return signedPsbt.signedRawTx;
  }
}
